import { render } from "./footer-socials-list.vue?vue&type=template&id=a72262d4"
import script from "./footer-socials-list.vue?vue&type=script&lang=js"
export * from "./footer-socials-list.vue?vue&type=script&lang=js"

import "./footer-socials-list.vue?vue&type=style&index=0&id=a72262d4&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__